import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', color = '#B6862C', text = '' }) => {
  const sizeClass = `spinner-${size}`;
  
  return (
    <div className="spinner-container">
      <div 
        className={`spinner ${sizeClass}`}
        style={{ borderTopColor: color }}
      ></div>
      {text && <span className="spinner-text">{text}</span>}
    </div>
  );
};

export default Spinner;